export const LOGIN_WITH_BOTH = 0; // 不限
export const LOGIN_ONLY_WITH_WX = 1; // 仅限微信登录
export const LOGIN_ONLY_WITH_QQ = 2; // 仅限QQ登录
